module.exports = __webpack_public_path__ + "img/0Q3B8222_Wood.1c4392b2.jpg";